<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-80 start-project">
        <md-card class="">
          <form>
            <md-card-header class="md-card-header-icon">
              <div class="card-icon">
                <md-icon>group</md-icon>
              </div>
              <h4 class="title">
                Edit User
              </h4>
            </md-card-header>
            <md-card-content class="content-inputs">
              <div class="md-layout start-inputs">
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>First Name</label>
                  <md-input v-model="user.user.first_name" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Last Name</label>
                  <md-input v-model="user.user.last_name" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>User Email</label>
                  <md-input v-model="user.user.email" required type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Phone Number</label>
                  <md-input v-model="user.user.phone_number"  type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>Company Position</label>
                  <md-input v-model="user.user.company_position"  type="text"></md-input>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>GPR Access</label>
                  <md-select v-model="user.user.gpr_access">
                    <md-option value="true">Yes</md-option>
                    <md-option value="false">No</md-option>
                  </md-select>
                </md-field>
                <md-field class="md-layout-item md-size-45 md-medium-size-100">
                  <label>GPR Task Type</label>
                  <md-select v-model="user.user.gpr_task_type">
                    <md-option value="imperial">Imperial</md-option>
                    <md-option value="metric">Metric</md-option>
                  </md-select>
                </md-field>
              </div>
            </md-card-content>
            <md-card-actions md-alignment="right">
              <md-button class="md-success" v-on:click="editUser">Edit User</md-button>
            </md-card-actions>
          </form>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api';
import idx from 'idx';

export default {
  components: {
    
  },
  data() {
    return {
      user: {
        user: {

        }
      },
    }
  },
  created(){
    var userId = this.$route.params.id;
    if (userId == undefined) {
      this.$router.push("users");
    } else {
      api.getUserData(userId).then((response) => {
        console.log('get user data', response)
        this.user = idx(response, _ => _.data);
        // this.isLoading = false;

      });
    }
  },
  methods: {
    editUser() {
      console.log('user data', this.user)
      console.log('this.user.user.id', this.user.user.id)
      api.updateUserData2(this.user.user.id, this.user).then((response) => {
        this.notifyVue(`You have successfully edited ${this.user.user.first_name}.`);
        this.$router.push("/users");
      })
    },
    notifyVue(message) {
      this.$notify({
        timeout: 2500,
        message: message,
        icon: "done_all",
        horizontalAlign: "left",
        verticalAlign: "top",
        type: "success"
      });
    },
    onChildClick (value) {
    },
  },
};
</script>
<style lang="scss">
  .extra-users {
    width: 100%;
  }

  .employee-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-around;
    .md-layout-item{
      // display: inline-block;
    }
  }
</style>
